import { render, staticRenderFns } from "./addOrg.vue?vue&type=template&id=68e7e7fa&"
import script from "./addOrg.vue?vue&type=script&lang=js&"
export * from "./addOrg.vue?vue&type=script&lang=js&"
import style0 from "./addOrg.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addOrg.vue"
export default component.exports